export const appBuildAssetsDir = "content-assets"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, interactive-widget=resizes-content"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/content-static/favicon.ico"},{"rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous","href":"/content-static/fonts/lato-latin-ext_latin-300.woff2"},{"rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous","href":"/content-static/fonts/lato-latin-ext_latin-regular.woff2"},{"rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous","href":"/content-static/fonts/lato-latin-ext_latin-700.woff2"},{"rel":"preconnect","href":"https://api.trustpilot.com"},{"rel":"preconnect","href":"https://www.anyvan.com"},{"rel":"preconnect","href":"https://snowplow.anyvan.com"},{"rel":"preconnect","href":"https://cdn-ukwest.onetrust.com"}],"style":[],"script":[],"noscript":[],"title":"Anyvan","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true